
import { defineComponent } from 'vue'
import panelDescriptor from './OlapFilterPanelDescriptor.json'

export default defineComponent({
    components: {},
    props: { filterCardList: { type: Array, required: true }, olapDesigner: { type: Object } },
    emits: ['dragging', 'dragend', 'showMultiHierarchy', 'openFilterDialog'],
    data() {
        return {
            panelDescriptor
        }
    },
    created() {},
    methods: {
        onDragStart(event, filter, filterId) {
            event.dataTransfer.setData('text', JSON.stringify(filter))
            event.dataTransfer.dropEffect = 'move'
            event.dataTransfer.effectAllowed = 'move'
            // @ts-ignore
            this.$refs[`${filterId}`].classList.add('filter-dragging')
            this.$emit('dragging')
        },
        removeDragClass(filterId) {
            // @ts-ignore
            this.$refs[`${filterId}`].classList.remove('filter-dragging')
            this.$emit('dragend')
        },
        openFilterDialog(filter: any) {
            this.$emit('openFilterDialog', { filter: filter, type: 'slicer' })
        },
        filterIsActive(filter: any) {
            let isActive = false
            for (let i = 0; i < filter.hierarchies.length; i++) {
                if (filter.hierarchies[i].slicers && filter.hierarchies[i].slicers.length > 0) {
                    isActive = true
                    break
                }
            }
            return isActive
        },
        getNumberOfActiveLevels(filter: any) {
            const dynamicSlicers = this.olapDesigner?.template?.wrappedObject.olap.DYNAMIC_SLICER
            if (!dynamicSlicers) return 0
            let numberOfActiveLevels = 0
            for (let i = 0; i < dynamicSlicers.length; i++) {
                if (dynamicSlicers[i].HIERARCHY === filter.uniqueName) numberOfActiveLevels++
            }
            return numberOfActiveLevels
        },
        getSlicersTooltip(filter: any) {
            let values = ''
            if (!filter || !filter.hierarchies[0] || !filter.hierarchies[0].slicers) return values

            for (let i = 0; i < filter.hierarchies[0].slicers.length; i++) {
                values += filter.hierarchies[0].slicers[i].name
                values += i === filter.hierarchies[0].slicers.length - 1 ? ' ' : ', '
            }

            return values
        }
    }
})
